import TrackingElement from '../../../elements/tracking/TrackingElement';
import ShoppingCartEvents from '../../../structures/_shopping-cart/ShoppingCartEvents';
import pushEcommerceTrackingEvent from '../../../elements/tracking/helpers/pushEcommerceTrackingEvent';
import toTrackableCartProduct from '../../../elements/tracking/transformer/toTrackableCartProduct';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';
import { formatNumber } from '../../../elements/tracking/helpers/number-formatter';
import getItemsArray from '../../../elements/tracking/helpers/getItemsArray';
import checkoutPageTrackingStore from '../../../elements/tracking/stores/checkout-page-tracking-store';

class ShoppingCartPageTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            this.cart = JSON.parse(this.$trackingTarget.getAttribute('cart-object'));
            this.trackShoppingCartDetail();

            this.$trackingTarget?.addEventListener(ShoppingCartEvents.ITEM_REMOVE, ({ detail: product }) => {
                const productToRemove = this.cart?.items?.find(item => product.id === item.sku);
                this.trackProductRemoveFromCart(productToRemove);
            });

            this.$trackingTarget?.addEventListener(ShoppingCartEvents.CART_CHANGED, ({ detail: cart }) => {
                this.cart = cart;
            });

            // handle double "submit" buttons in DOM
            const dataCheckoutButtons = this.$trackingTarget.querySelectorAll('[data-checkout-btn]');
            dataCheckoutButtons.forEach(checkoutBtn => {
                checkoutBtn.addEventListener('click', () => {
                    this.setCheckoutDetailsToStore();
                    this.trackCheckoutBegin();
                });
            });
        }
    }

    properties() {
        return {
            target: 'shopping-cart-page',
            cart: null,
            checkoutStore: checkoutPageTrackingStore,
        };
    }

    get cart() {
        if (!this.$trackingTarget) {
            return undefined;
        }
        return this.$trackingTarget?.cartObject;
    }

    trackProductRemoveFromCart(product = {}) {
        pushEcommerceTrackingEvent('remove_from_cart', {
            currency: CurrencyFormatter.currency(),
            value: formatNumber(product?.totalPrice),
            items: [toTrackableCartProduct(product)],
        });
    }

    trackShoppingCartDetail() {
        if (!this.cart) {
            return;
        }

        pushEcommerceTrackingEvent('view_cart', {
            currency: CurrencyFormatter.currency(),
            value: formatNumber(this.cart?.totalPrice),
            items: getItemsArray(this.cart?.items, toTrackableCartProduct),
        });
    }

    setCheckoutDetailsToStore() {
        checkoutPageTrackingStore.setItem({
            currency: CurrencyFormatter.currency(),
            value: formatNumber(this.cart?.totalPrice),
            coupon: this.cart?.discountName,
            shipping_tier: '',
            payment_type: '',
            items: getItemsArray(this.cart?.items, toTrackableCartProduct),
        });
    }

    trackCheckoutBegin() {
        this.checkoutStore?.trackEvent('checkout_begin');
    }
}

customElements.define('shopping-cart-page-tracking', ShoppingCartPageTracking);
